export const fieldName = {
  internalQuote: 'internalQuote',
  assignTo: 'assignTo',
  consultants: 'consultants',
  isQuoted: 'isQuoted',
  quotedAt: 'quotedAt',
};

export const dropdownDimensions = { maxHeight: 200, maxWidth: 210 };
